import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { fetchCategoriesSuccess } from '../../state/actions/fetch-categories-success/index.tsx';
import { setKbHub } from '../../state/actions/set-knowledge-hub/index.tsx';
import KnowledgeHubSetter from './view.tsx';

export default connect(() => ({}), {
	onSetKbHub: setKbHub,
	setCategoriesData: fetchCategoriesSuccess,
})(KnowledgeHubSetter);
